import type { TableV2Counts } from '@/features/shared/components/tableSystem/TableV2Primitives';
import type { BuildStatus } from '@flowqa/shared';

export const emptyOperationPassRateCounts = (): TableV2Counts => ({
  total: 0,
  passed: 0,
  failed: 0,
  errored: 0,
  skipped: 0,
  untested: 0,
});

export const buildOperationPassRateCountsFromStatus = (status: BuildStatus): TableV2Counts =>
  buildOperationPassRateCountsFromStatusCounts({ [status]: 1 });

export const buildOperationPassRateCountsFromStatusCounts = (
  counts: Partial<Record<BuildStatus, number>> | null | undefined,
): TableV2Counts => {
  const queued = counts?.queued ?? 0;
  const running = counts?.running ?? 0;
  const completed = counts?.completed ?? 0;
  const failed = counts?.failed ?? 0;

  return {
    total: queued + running + completed + failed,
    passed: completed,
    failed,
    errored: 0,
    skipped: 0,
    untested: queued + running,
  };
};

export const buildOperationPassRateCountsFromStatusSummaries = (
  summaries: Array<{ status: BuildStatus }> | null | undefined,
): TableV2Counts => {
  const counts: Partial<Record<BuildStatus, number>> = {};
  (summaries ?? []).forEach((summary) => {
    counts[summary.status] = (counts[summary.status] ?? 0) + 1;
  });
  return buildOperationPassRateCountsFromStatusCounts(counts);
};
